/**
 * Section: Modals Controller (custom-modals.js)
 * Features:
 * - Contact & Booking Modal ("Book a Call" / "Talk to JULI")
 * - Video Testimonial Popup Modal (Figma Node 295:18956)
 */

(function () {
  'use strict';

  function initModals() {
    const contactModal = document.getElementById('juli-contact-modal');
    const videoModal = document.getElementById('juli-video-modal');
    const videoPlayer = document.getElementById('juli-video-player');
    const videoToggleBtn = document.getElementById('juli-video-toggle-btn');
    const videoContainer = document.querySelector('.juli-video-modal-container');

    function openModal(modal) {
      if (typeof modal === 'string') {
        modal = document.getElementById(`juli-${modal}-modal`) || document.querySelector(`[data-modal-id="${modal}"]`);
      }
      if (!modal) return;
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      const firstInput = modal.querySelector('input:not([type="hidden"]), textarea, button:not([data-juli-modal-close])');
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 150);
      }
    }

    function closeModal(modal) {
      if (typeof modal === 'string') {
        modal = document.getElementById(`juli-${modal}-modal`) || document.querySelector(`[data-modal-id="${modal}"]`);
      }
      if (!modal) return;
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
      if (modal === videoModal && videoPlayer) {
        videoPlayer.pause();
        videoPlayer.currentTime = 0;
        if (videoContainer) {
          videoContainer.classList.remove('is-paused');
        }
      }
    }

    // Expose globally for notification or other triggers
    window.JuliModals = {
      openModal,
      closeModal
    };

    // Trigger: Contact & Booking ("Book a Call" / "Talk to JULI")
    document.querySelectorAll('[data-juli-modal="contact"]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openModal(contactModal);
      });
    });

    // Trigger: Video Modal (from play button or entire card)
    document.querySelectorAll('[data-juli-modal="video"]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const videoSrc = trigger.getAttribute('data-video-src');
        const isMobile = window.matchMedia('(max-width: 768px)').matches;

        if (videoPlayer && videoSrc) {
          if (videoPlayer.src !== videoSrc) {
            videoPlayer.src = videoSrc;
          }

          if (isMobile) {
            videoPlayer.setAttribute('controls', 'controls');
            videoPlayer.controls = true;
          } else {
            videoPlayer.removeAttribute('controls');
            videoPlayer.controls = false;
          }

          videoPlayer.play().catch(() => {});

          if (videoContainer) {
            videoContainer.classList.remove('is-paused');
          }

          // Trigger iOS native fullscreen player if supported
          if (isMobile && typeof videoPlayer.webkitEnterFullscreen === 'function') {
            try {
              videoPlayer.webkitEnterFullscreen();
            } catch (err) {}
          }
        }
        openModal(videoModal);
      });
    });

    // Close modal when iOS WebKit native fullscreen exits ("Done" pressed)
    if (videoPlayer) {
      videoPlayer.addEventListener('webkitendfullscreen', () => {
        closeModal(videoModal);
      });
    }

    // Play/Pause Video Toggle within Modal
    function toggleVideoPlay() {
      if (!videoPlayer) return;
      if (videoPlayer.paused) {
        videoPlayer.play();
        if (videoContainer) videoContainer.classList.remove('is-paused');
        updatePlayIcons(false);
      } else {
        videoPlayer.pause();
        if (videoContainer) videoContainer.classList.add('is-paused');
        updatePlayIcons(true);
      }
    }

    function updatePlayIcons(isPaused) {
      const playIcon = document.querySelector('.juli-icon-play');
      const pauseIcon = document.querySelector('.juli-icon-pause');
      if (playIcon && pauseIcon) {
        if (isPaused) {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        } else {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        }
      }
    }

    if (videoPlayer) {
      videoPlayer.addEventListener('click', toggleVideoPlay);
      videoPlayer.addEventListener('pause', () => {
        if (videoContainer) videoContainer.classList.add('is-paused');
        updatePlayIcons(true);
      });
      videoPlayer.addEventListener('play', () => {
        if (videoContainer) videoContainer.classList.remove('is-paused');
        updatePlayIcons(false);
      });
    }

    if (videoToggleBtn) {
      videoToggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleVideoPlay();
      });
    }

    // Close buttons
    document.querySelectorAll('[data-juli-modal-close]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const modal = btn.closest('.juli-modal-backdrop') || document.querySelector('.juli-modal-backdrop.is-active');
        if (modal) closeModal(modal);
      });
    });

    // Click outside backdrop to close
    document.querySelectorAll('.juli-modal-backdrop').forEach((modal) => {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          closeModal(modal);
        }
      });
    });

    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const activeModal = document.querySelector('.juli-modal-backdrop.is-active');
        if (activeModal) {
          closeModal(activeModal);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModals);
  } else {
    initModals();
  }
})();
